export default __webpack_public_path__ + "static/rs-empresarial_01-c35d2e217a2d6d35e05894e95d722d49.jpg";